import { MantinePrimaryShade, useMantineTheme } from "@mantine/core";
import { bbox } from "@turf/bbox";
import { useEffect } from "react";
import { Layer, Source, useMap } from "react-map-gl/maplibre";
import { useColorMode } from "shared/hooks/useColorMode";

type MapBoundsCtrlProps = {
    noFit?: boolean;
    stroke?: string;
    features: GeoJSON.Feature[];
};

export const MapFeatureOverlay = ({ features, stroke, noFit: nofit }: MapBoundsCtrlProps) => {
    const map = useMap();
    const theme = useMantineTheme();
    const { isDark } = useColorMode();

    useEffect(() => {
        if (features.length === 0) return;

        const bounds = bbox({
            type: "FeatureCollection",
            features,
        });

        const [minLng, minLat, maxLng, maxLat] = bounds;
        if (nofit) return;

        map.current?.fitBounds(
            [
                [minLng, minLat],
                [maxLng, maxLat],
            ],
            { padding: 40, duration: 0 },
        );
    }, [features]);

    return (
        <Source
            id="multi-boundary"
            type="geojson"
            data={{
                type: "FeatureCollection",
                features,
            }}
        >
            <Layer
                id="multi-boundary-fill"
                type="fill"
                paint={{
                    "fill-color": ["coalesce", ["get", "fill"], "rgba(0,0,0,0)"],
                    "fill-opacity": 0.35,
                }}
            />
            <Layer
                id="multi-boundary-layer"
                type="line"
                layout={{ "line-join": "round", "line-cap": "round" }}
                paint={{
                    "line-color":
                        theme.colors[stroke ?? theme.primaryColor][(theme.primaryShade as MantinePrimaryShade)[isDark ? "dark" : "light"]],
                    "line-width": 2,
                }}
            />
        </Source>
    );
};
